import { useTranslation } from '@datacamp/le-shared-components';
import { Button } from '@datacamp/waffles/button';
import { ArrowRight } from '@datacamp/waffles/icon';
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const NextButton = _ref => {
  let {
    onClick
  } = _ref;
  const {
    t
  } = useTranslation();
  return ___EmotionJSX(Button, {
    "data-attributes": {
      cy: 'next-button'
    },
    onClick: onClick,
    size: "medium",
    variant: "primary"
  }, t('MultiStepInstructions.next'), ___EmotionJSX(ArrowRight, null));
};